import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view on every SPA route change. Initial page_view is
// disabled in index.html (send_page_view: false) so this is the single source.
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = pathname + search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
